import { useQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import { layoutQueryKeys } from "./layoutQueryKeys";

/**
 * One saved layout by id. Disabled, and never fetched or cached as a layout,
 * until a non-empty id and the current organization are both known.
 */
export function useLayout(layoutId: string | undefined) {
  const { layoutService } = useDomainServices();
  const { currentOrganization } = useAuth();

  const target =
    layoutId && currentOrganization
      ? { layoutId, orgId: currentOrganization.org_id }
      : undefined;

  return useQuery({
    queryKey: layoutQueryKeys.id(target?.layoutId ?? ""),
    queryFn: ({ signal }) => {
      if (target === undefined) {
        return Promise.reject(new Error("Layout query is disabled"));
      }
      return layoutService.getLayoutById(target.layoutId, target.orgId, {
        abortSignal: signal,
      });
    },
    enabled: target !== undefined,
  });
}
